<template>
  <div
    class="flex -mx-4 -my-1.5"
    :class="vertical ? 'items-start flex-col' : 'items-center'"
  >
    <div
      class="px-4 py-1.5"
      :class="{ 'w-full': vertical }"
      v-for="(option, optionIndex) in options"
      :key="`cf${option.value}`"
    >
      <label class="custom-radio">
        <input
          :class="{ failed: error }"
          :id="`${id}${optionIndex}`"
          :value="option.value"
          type="radio"
          v-bind="$attrs"
          :checked="option.value === modelValue"
          @change="$emit('update:modelValue', option.value)"
        />
        {{ option.label }}
      </label>
    </div>
  </div>
</template>

<script>
import { onMounted } from 'vue';

export default {
  name: 'BooleanGroupField',
  props: {
    id: {
      type: [String, Number],
      default: ''
    },
    label: {
      type: String
    },
    vertical: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    modelValue: String
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    onMounted(() => {
      if (!props.modelValue && props.options.length) {
        let first = [...props.options].shift();
        emit('update:modelValue', first.value);
        emit('change', new Event('change'));
      }
    });
  }
};
</script>
